import { Collapse } from "antd";
import type { ReactNode } from "react";

type Item = { q: string; a: ReactNode };

type Props = {
    items: Item[];
    idPrefix?: string;
    /** Card-per-item styling with +/- toggles (landing redesign). */
    cards?: boolean;
};

export default function FaqAccordion({ items, idPrefix = "faq", cards = false }: Props) {
    return (
        <Collapse
            bordered={false}
            expandIconPlacement="end"
            className={cards ? "gt-faq gt-faq--cards" : "gt-faq"}
            expandIcon={
                cards
                    ? ({ isActive }) => (
                          <span className="gt-faq__toggle" aria-hidden="true">
                              {isActive ? "−" : "+"}
                          </span>
                      )
                    : undefined
            }
            items={items.map((item, idx) => ({
                key: `${idPrefix}-${idx}`,
                // Keep collapsed answers mounted in the DOM. Without this the
                // served HTML contains only the questions, so AI crawlers that
                // read visible text (not JSON-LD) never see the answers.
                forceRender: true,
                label: <span className="gt-body gt-faq__question">{item.q}</span>,
                children:
                    typeof item.a === "string" ? (
                        <p className="gt-faq__answer">{item.a}</p>
                    ) : (
                        <div className="gt-faq__answer">{item.a}</div>
                    ),
            }))}
        />
    );
}
